var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.fenquData)?_c('div',{ref:"duibifenqubi",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"duibifenqubi"}}):_c('no-data-temporarily',{staticStyle:{"width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }